import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import './Main.css';

const Main = () => {
    const {t} = useTranslation();

    const products = [
        {
            id: 'eat',
            path: '/eat-slowly',
            accent: 'var(--eat)',
            nameKey: 'eat_slowly_name',
            taglineKey: 'eat_slowly_tagline',
            year: '/25',
        },
        {
            id: 'spend',
            path: '/spend-gently',
            accent: 'var(--spend)',
            nameKey: 'spend_gently_name',
            taglineKey: 'spend_gently_tagline',
            year: '/26',
        },
        {
            id: 'fridge',
            path: '/fridge-organizer',
            accent: 'var(--fridge)',
            nameKey: 'fridge_organizer_name',
            taglineKey: 'fridge_organizer_tagline',
            year: '/26',
        },
    ];

    const principles = ['essential', 'private', 'calm', 'daily'];

    return (
        <div className="home container">
            <section className="home-hero">
                <div className="hero-headline">
                    <h1>
                        <span className="brand-pers">Pers</span>
                        <span className="brand-normal">
                            n<span className="brand-mark-o">o</span>rmal
                        </span>
                    </h1>
                    <p className="hero-annotation">{t('home.hero.annotation')}</p>
                </div>

                <div className="hero-below">
                    <div className="hero-lead">
                        <p>{t('home.hero.sub')}</p>
                        <Link className="pill-btn" to="/contact">
                            {t('home.close.link')}
                            <span aria-hidden="true">→</span>
                        </Link>
                    </div>
                    <div className="hero-side">
                        <span className="hero-side-label">{t('home.hero.apps_label')}</span>
                        <Link to="/eat-slowly">{t('eat_slowly_name')}</Link>
                        <Link to="/spend-gently">{t('spend_gently_name')}</Link>
                        <Link to="/fridge-organizer">{t('fridge_organizer_name')}</Link>
                    </div>
                </div>
            </section>

            <section className="home-made" aria-labelledby="home-made-title">
                <div className="made-head">
                    <h2 id="home-made-title">
                        {t('home.made.title')}
                        <sup>({products.length})</sup>
                    </h2>
                    <span>{t('home.made.note')}</span>
                </div>
                <div className="made-list">
                    {products.map((product) => (
                        <Link
                            to={product.path}
                            className="made-item"
                            style={{'--accent': product.accent}}
                            key={product.id}
                        >
                            <div className="made-copy">
                                <strong>{t(product.nameKey)}</strong>
                                <span className="made-meta">
                                    {t(product.taglineKey)} · {t('p.platform_note')}
                                </span>
                            </div>
                            <span className="made-year">{product.year}</span>
                        </Link>
                    ))}
                </div>
            </section>

            <section className="home-process">
                <div className="process-intro">
                    <h2>{t('home.principles.title')}</h2>
                    <p>{t('home.process.lede')}</p>
                </div>
                <div className="process-list">
                    {principles.map((key, index) => (
                        <div className="process-row" key={key}>
                            <span className="process-num">{String(index + 1).padStart(2, '0')}.</span>
                            <div>
                                <strong>{t(`home.principles.${key}.title`)}</strong>
                                <p>{t(`home.principles.${key}.body`)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="home-close">
                <h2>{t('home.close.title')}</h2>
                <Link className="pill-btn" to="/contact">
                    {t('home.close.link')}
                    <span aria-hidden="true">→</span>
                </Link>
            </section>
        </div>
    );
};

export default Main;
